// extracted by mini-css-extract-plugin
export default {"button":"SingInButton-module--button--3J4xM","wrapper":"SingInButton-module--wrapper--3gCGn","disabled":"SingInButton-module--disabled--1RfbG"};